import { render, staticRenderFns } from "./OperationConfigDetailDog.vue?vue&type=template&id=68a2b828&scoped=true"
import script from "./OperationConfigDetailDog.vue?vue&type=script&lang=js"
export * from "./OperationConfigDetailDog.vue?vue&type=script&lang=js"
import style0 from "./OperationConfigDetailDog.vue?vue&type=style&index=0&id=68a2b828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2b828",
  null
  
)

export default component.exports